const mutations = {
  set(state, c) {
    state[c.name] = c.value;
  },
};

const state = {};

export default {
  namespaced: true,
  actions: {},
  getters: {},
  state,
  mutations,
};
